import Swiper, { Navigation } from 'swiper';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const swipers = [];

    document.querySelectorAll('.Offer__content').forEach((content) => {
        const el = content.querySelector('.offer-swiper');
        if (!el) return;

        const swiper = new Swiper(el, {
            modules: [Navigation],
            loop: false,
            speed: 600,
            spaceBetween: 32,
            slidesPerView: 1,
            breakpoints: {
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
            },
            navigation: {
                nextEl: content.querySelector('.offer-swiper-button-next'),
                prevEl: content.querySelector('.offer-swiper-button-prev'),
            },
        });

        swipers.push({ content, swiper });
    });

    document.querySelectorAll('.Offer__tab').forEach((btn) => {
        btn.addEventListener('click', () => {
            const tab = btn.dataset.tab;

            document.querySelectorAll('.Offer__tab').forEach(b => b.classList.remove('is-active'));
            document.querySelectorAll('.Offer__content').forEach(c => c.classList.remove('is-active'));

            btn.classList.add('is-active');
            const activeContent = document.querySelector(`.Offer__content[data-content="${tab}"]`);
            activeContent.classList.add('is-active');

            // update swipera po pokazaniu - żeby przeliczył wymiary
            const found = swipers.find(s => s.content === activeContent);
            if (found) found.swiper.update();
        });
    });
});